<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <span v-if="!mostrarTextoCompleto">
    {{ textoCorto }}...
    <span v-on:click="mostrarTextoCompleto = true" style="color: #5B60E7; cursor: pointer;">Ver más...</span>
    </span>
      <span v-else>
      {{ textoCompleto }}
    </span>
  </div>

</template>

<script>
export default {
  name: "TextoVerMas",
  props: {
    textoCompleto: String,
    maxLength: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    mostrarTextoCompleto: false
  }),
  computed: {
    textoCorto() {
      return this.textoCompleto.substring(0, this.maxLength);
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>